import styled from "styled-components/macro";

export const AppContainer = styled.div`
  background-color: ${(props) => props.theme.backgroundPrimary};
  width: 100%;
  & > h1 {
    margin: 0;
  }
`;
